import { Icon } from '@/general/Icons/Icon';
import { FC, ReactNode } from 'react';

import { ButtonIcon } from '@/general/components/Button/ButtonIcon';
import { isNil } from '@/utils/isNil';

import styles from './CheckoutDescription.module.scss';

interface CheckoutDescriptionProps {
  title: ReactNode;
  description?: ReactNode;
  onBack?: () => void;
}

export const CheckoutDescription: FC<CheckoutDescriptionProps> = ({ title, description, onBack }) => (
  <section className={styles.wrapper}>
    <div className={styles.titleGroup}>
      <h3 className={styles.title} data-testid="checkout-description-title">
        {title}
      </h3>
      {!isNil(onBack) && (
        <ButtonIcon
          icon={<Icon name="arrow-up" />}
          title="Back"
          variant="secondary"
          size="small"
          onClick={onBack}
          data-testid="CHECKOUT_BACK_BUTTON"
        />
      )}
    </div>
    {description && <p className={styles.description}>{description}</p>}
  </section>
);
